import styled, { css } from 'styled-components'
import AppButton from 'Components/AppButton'
import { BREAK_POINT_SM, BREAK_POINT_MD } from '@CSSVars/variables'
import { GREY_BACKGROUND, TEXT_GREY, CLICKABLE_COLOR, OUTLINE_COLOR,
  SELECTED_ITEM_BG_COLOR, LINK_COLOR } from '@CSSVars/colors'

export const _MobileAgentContainer = styled.div`
  display: none;
  @media screen and (max-width: 1280px) {
    display: flex;
    flex-direction: column;
    width: 400px;
    margin: 0 auto;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
  }
  `
export const _MobileAgentCard = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 24px;
    background-color: ${GREY_BACKGROUND};
    border-radius: 10px;
    justify-content: center;
`

export const _AgentImage = styled.div`
  width: 80px;
  height: 80px;
  margin-right: 16px;
  border-radius: 50%;
  background-size: cover;
  backface-visibility: hidden;
`
export const _HoverPressedStates = css`
  color: ${LINK_COLOR};
  @media (hover: hover){
    &:hover{
      color:${CLICKABLE_COLOR};
    }
  }
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
`

export const _AgentName = styled.div`
  margin-bottom: 3px;
  font-size: 16px;
  line-height: 22px;
  ${_HoverPressedStates};
  text-decoration: underline;
`

export const _AgentTitle = styled.div`
  font-size: 12px;
  line-height: 22px;
  color: ${TEXT_GREY};
`

export const _AgentBrokerageName = styled.div`
  font-size: 12px;
  line-height: 22px;
  color: ${TEXT_GREY};
`

export const _AgentPhone = styled.div`
  a {
    font-size: 12px;
    line-height: 22px;
  }
  ${_HoverPressedStates};
  text-decoration: underline;
  margin-top: 3px;
`

export const _ContactBtn = styled(AppButton)`
  margin-top: 10px;
  border-radius: 10px;
  height: 44px;
  color: ${LINK_COLOR};
`

export const _MLSInfo = styled.div`
  div:first-child {
    padding: 24px 0;
    color: ${TEXT_GREY};
    font-size: 12px;
    line-height: 16px;
  }
  >div {
    margin-bottom: 7px;
    color: ${TEXT_GREY};
    font-size: 12px;
    line-height: 22px;
  }
`

export const _SeparatorLine = styled.div`
  height: 1px;
  width: 100%;
  background: ${OUTLINE_COLOR};
  margin-right: -24px;
  margin-bottom: 24px;
  @media screen and (min-width: ${BREAK_POINT_SM}) {
    display: none;
  }
`
